var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contract-component',{attrs:{"title":"Seleccione el plan que desee contratar","disabled":false,"btn_text":"Contratar","submit_func":_vm.submit,"submitting":_vm.submitting}})}
var staticRenderFns = []

export { render, staticRenderFns }